import { render, staticRenderFns } from "./LomEventsList.vue?vue&type=template&id=aa62161c"
import script from "./LomEventsList.vue?vue&type=script&lang=js"
export * from "./LomEventsList.vue?vue&type=script&lang=js"
import style0 from "./LomEventsList.vue?vue&type=style&index=0&id=aa62161c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports